import { DefaultStepper } from 'Components/common/DefaultStepper'
import { StepperContainer } from './styles'

export const StepperForm = ({ activeStep, steps }) => {
  return (
    <StepperContainer>
      <DefaultStepper steps={steps} activeStep={activeStep} shape="rounded" />
    </StepperContainer>
  )
}
